import apiClient from "services/apiClient";

async function addMarkerGroup(data: any) {
  const url = `/admin/marker-groups`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addMarkerGroup;
